<template>
  <ButtonSquare
    :activeState="active ? 'active' : 'inactive'"
    :hoverExplanationText="$t('general__view__parallel')"
    :imgSource="require('@/assets/icon-indoorview-split.svg')"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'

export default {
  name: 'SplitViewButton',
  components: {
    ButtonSquare
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
